import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const UnderMaintenance = () => {


    return (
        <div className="min-vh-100 d-flex align-items-center">
            <Container className="py-5">
                <Row className="justify-content-center text-center">
                    <Col lg={8} md={10} className="px-4">
                        <Card className="card-hover menu-item-card mb-0 mx-auto">
                            <Card.Body>
                                {/* Maintenance Illustration */}
                                <div className="position-relative mb-4">
                                    <i className="ri-tools-line text-danger display-4" ></i>
                                    <h1 className="display-4 fw-bold text-danger mt-3">Under Maintenance</h1>
                                </div>

                                {/* Maintenance Message */}
                                <h2 className="display-5 fw-bold mb-3">We'll Be Back Soon!</h2>
                                <p className="lead text-muted mb-4">
                                    We're currently performing scheduled maintenance. We apologize for the inconvenience.
                                    Our team is working hard to improve your experience. We'll be back up and running shortly! 🛠️
                                </p>


                                {/* Status Update */}
                                <div className=" p-4 rounded-3 mb-5">
                                    <h5 className="mb-3">Latest Update</h5>
                                    <p className="mb-0">
                                        <i className="ri-information-line me-2 text-primary"></i>
                                        Performing scheduled maintenance to improve performance and add new features.
                                    </p>
                                </div>

                                {/* Contact Info */}
                                <div className="mt-5 pt-4 border-top">
                                    <p className="text-muted mb-4">Need immediate assistance? Contact our support team</p>
                                    <div className="d-flex flex-wrap justify-content-center gap-4">
                                        <a href="mailto:support@reshto.com" className="text-decoration-none">
                                            <i className="ri-mail-line me-2"></i> support@reshto.com
                                        </a>
                                        <span className="text-muted d-none d-md-inline">|</span>
                                        <a href="tel:+1234567890" className="text-decoration-none">
                                            <i className="ri-phone-line me-2"></i> +1 (234) 567-890
                                        </a>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default UnderMaintenance;
